module.exports = __webpack_public_path__ + "fonts/Poppins-700-latin18.d86662f.woff2";